export default __webpack_public_path__ + "static/media/factory-future.36e7c75d.svg";